/* eslint-disable */
export const SERVICE_URL = location.origin;

export const BUILD_VERSION = process.env.BUILD_COMMIT;
export const BASE_API_URL_FLAT = process.env.REACT_APP_API_URL_FLAT;
export const BASE_WSS_URL_FLAT = process.env.REACT_APP_WSS_URL_FLAT;
export const BASE_API_URL = `${process.env.REACT_APP_API_URL || '/api'}`;
export const SOCIAL_REDIRECT_URL = process.env.SOCIAL_REDIRECT_URL;
export const APP_CLIENT_ID = process.env.APP_CLIENT_ID;
export const APP_CLIENT_SECRET = process.env.APP_CLIENT_SECRET
export const GOOGLE_CLIENT_ID = process.env.GOOGLE_CLIENT_ID;
export const MICROSOFT_CLIENT_ID = process.env.MICROSOFT_CLIENT_ID;
export const MICROSOFT_TENANT_ID = process.env.MICROSOFT_TENANT_ID;
export const MICROSOFT_TENANT_URL = process.env.MICROSOFT_TENANT_URL;
export const MICROSOFT_REDIRECT_URI =
  // 'https://srm-ppa-dev.azurewebsites.net' + process.env.MICROSOFT_REDIRECT_URI;
  // location.origin + process.env.MICROSOFT_REDIRECT_URI;
  location.origin;
// TODO: clean the code after testing and confirming


// For debugging
export const REACT_APP_HTTP_URL = process.env.REACT_APP_HTTP_ENDPOINT;
console.log('***************** For Testing *****************')
console.log(' REACT_APP_HTTP_URL --> ', REACT_APP_HTTP_URL)
console.log('***************** For Testing *****************')
// For debugging

export const MATOMO_URL = process.env.MATOMO_URL;
export const MATOMO_SITE_ID = process.env.MATOMO_SITE_ID;
export const getMatomoSurveyToolName = (country) => {
  return `Price Pack Architecture (PPA-EDGE) - ${country}`;
};
export const getSurveyImplementation = (country) => ({
  title: 'Take Survey',
  routePathDev:
    `https://apps.powerapps.com/play/e/default-2fc13e34-f03f-498b-982a-7cb446e25bc6/a/6d08a755-20a3-4871-873c-f2f4cbbee092?tenantId=2fc13e34-f03f-498b-982a-7cb446e25bc6&hint=22704cf4-8559-45e6-ae98-21149a41ab18&sourcetime=1723464257330&dataProductName=Price%20Pack%20Architecture%20(PPA-EDGE)%20-%20${country}`,
  routePathProd:
    `https://apps.powerapps.com/play/e/default-2fc13e34-f03f-498b-982a-7cb446e25bc6/a/7bbdc6e2-8b04-4c50-87a7-773cffccb792?tenantId=2fc13e34-f03f-498b-982a-7cb446e25bc6&source=AppSharedV3&sourcetime=1715173822958&dataProductName=Price%20Pack%20Architecture%20(PPA-EDGE)%20-%20${country}`,
  apiUrlDev:
    'https://automated-user-visit-dev.azurewebsites.net/api/user-visit-dev',
  apiUrlProd: 'https://automated-user-visit.azurewebsites.net/api/user-visit',
});
export const ENDPOINTS = {
  openGraphUri: `/api/graphql-open/`,
  graphUri: `/api/graphql/`,
  //authentication related endpoints
  getToken: `/api/auth/token/`,
  refreshToken: `/api/auth/token/`,
  convertSocialToken: `/api/auth/convert-token/`,
  verifyToken: `/api/user/token/verify/`,
  logout: `/api/auth/revoke-token`,

  homeUrl: `/home`,
  alertsUrl: `/alerts`,
  settingsUrl: `/settings`,
  adminUrl: `/admin`,
  profileSettingsUrl: `/settings/user`,
  loginUrl: `/login`,
  loginRedirect: `/app/auth`,
  logoutUrl: `/logout`,
  noaccess: "/noaccess",
  maintainance: "/maintainance",
  //errorPage: "/error"
};

export const REGEX = {
  EMAIL_PATTERN: '^[a-z0-9._%+-]+@[a-z0-9.-]+\\.[a-z]{2,4}$'
};

export const ERROR_MESSAGES = {
  REQUIRED: 'This is a mandatory field',
  VALID_EMAIL: 'Please provide a valid email id'
};

export const USER_METADATA = '/dashboards/usermetadata/';

export const FETCH_LANDING_PAGE_CARDS = '/accounts/landing/screen_mapping/';

export const SCREEN_METADATA = '/accounts/screens/';

export const FETCH_MODULE_ID_DATA = '/scenario/modules/';

export const FETCH_FILTER_FIELDS = '/filter_panel/filterpanel/scenario_module/';

export const FETCH_SIDEBAR_PAGEDATA = '/navigation/list/pages/';

export const FETCH_PH_RECOMMENDATION =
  '/scenario/planner_v2/ph_recommendation/';

export const FETCH_FILTER_FIELDS_FOR_COGS =
  '/filter_panel/filterpanel/scenario_module/';

export const FETCH_TABLE_DATA_FOR_COGS = '/scenario/kpi_update/get_table/';

export const RESET_COGS_TABLE_DATA = '/scenario/kpi_update/reset_data/';

export const GET_SIMULATED_COGS_TABLE_DATA = '/scenario/kpi_update/save_data/';

export const FETCH_FILTER_FIELDS_FOR_SM = '/scenario-manager/filter-panel/';

export const FETCH_TOP_N_VALUES =
  '/scenario/planner/get_additional_global_filters/';

export const FETCH_LOCAL_FILTERS = '/scenario/planner/localfilter/';

export const FETCH_LOCAL_FILTERS_V2 = '/scenario/planner_v2/local_filter/';

export const FETCH_DT_PBI_URL = '/scenario/common/get_dt_pbi_iframe_url/';

export const FETCH_SIMULATION_TABLE_METADATA = '/pricing/gettablemetadata/';

export const FETCH_SIMULATION_TABLE_INPUTS = '/pricing/getinputs/';

export const FETCH_SIMULATION_RESULTS = '/pricing/simulate/';

export const FETCH_SAVED_SCEANRIOS = '/pricing/loadsaved/';

export const SAVE_SCEANRIO = '/pricing/save/';

export const UPDATE_SCEANRIO = '/pricing/update/';

export const GET_LIST_OF_SAVEDSCENARIO_NAMES = '/pricing/nameslist/';

export const FETCH_RENOVATION_TABLE_DATA = '/scenario/renovation/get_table/';

export const RESET_NOTIFICATIONS = '/notifications/read_all/';

export const FETCH_SIMULATED_RENOVATION_TABLE_DATA =
  '/scenario/renovation/simulate/';

export const FETCH_SIMULATION_SUMMARY = '/scenario/summary/summary-metrics/';

export const GET_SUMMARY_TABLE_DATA = '/scenario/pricing/get_table/';

export const GET_SIMULATED_SUMMARY_TABLE_DATA = '/scenario/pricing/simulate/';

export const SAVE_SUMMARY_TABLE_DATA = '/scenario/pricing/save/';

export const RESET_PRICING_SUMMARY_TABLE_DATA =
  '/scenario/pricing/reset_simulation/';

export const GET_COMMENTS = '/scenario/comments/list/scenarioproductcomments/';

export const GET_COMMENTS_V2 = '/scenario/comments_v2/list/productcomments/';

export const RESET_DELIST_SUMMARY_TABLE_DATA =
  '/scenario/delist/reset_simulation/';

export const RESET_RENOVATION_SUMMARY_TABLE_DATA =
  '/scenario/renovation/reset_simulation/';

export const SAVE_RENOVATION_SIMULATION_TABLE_DATA =
  '/scenario/renovation/save/';

export const SAVE_DELIST_SUMMARY_TABLE_DATA = '/scenario/delist/save/';

export const GET_SIMULATED_DELIST_TABLE_DATA = '/scenario/delist/simulate/';

export const GET_DELIST_TABLE_DATA = '/scenario/delist/get_table/';

export const FETCH_GROWTH_DRIVERS_DATA =
  '/pricing/simulationsummary/sections/growth_drivers/';

export const CREATE_SCENARIO = '/scenario/create/';

export const UPDATE_SCENARIO = '/scenario/update/';

export const SAVE_AS_SCENARIO = '/scenario/saveas/';

export const GET_SCENARIOS = '/scenario/all/';

export const GET_SCENARIO_NAMES = '/scenario/names/';

export const GET_SCENARIO_MODULE_SEQ = '/scenario/module_sequence/';

export const SAVE_SCENARIO_PLANNER = '/scenario/planner/save/';

export const SAVE_SCENARIO_PLANNER_V2 =
  '/scenario/planner_v2/local_filter/save/';

export const GET_SCENARIO_ACCESS_CONFIG = '/scenario/access-configuration/';

export const GET_PH_RECOMMENDATION_CONFIG = '/scenario/common/ph_reco_legends/';

export const DOWNLOAD_PLANNER_OPPORTUNITY_SUMMARY =
  '/scenario/planner/download/';

export const DOWNLOAD_PLANNER_OPPORTUNITY_SUMMARY_V2 =
  '/scenario/planner_v2/download/';

export const GET_EAN_ZREP_TABLE_DATA = '/scenario/planner_v2/ean_zrep/';

export const SCENARIO_FILTERS = '/filter_panel/filterpanel/scenario_home/';

export const BULK_INPUTS_TABLE_ROWS = '/scenario/planner/bulkip/';

export const GET_GRID_DATA = '/scenario/planner/grid_view/';

export const GET_GRID_DATA_V2 = '/scenario/planner_v2/grid_view/';

export const GET_PRODUCTS_WITH_COMMENTS =
  '/scenario/comments/list/scenariocomments/';

export const GET_PRODUCTS_WITH_COMMENTS_V2 = '/scenario/comments_v2/list/';

export const GET_OPPORTUNITY_SUMMARY = '/scenario/planner/summary/';

export const GET_DRAWER_DATA = '/scenario/planner/drawerdetail/';

export const ADD_NEW_COMMENT = '/scenario/comments/create/';

export const ADD_NEW_COMMENT_V2 = '/scenario/comments_v2/create/';

export const UPDATE_COMMENT_V2 = '/scenario/comments_v2/update/';

export const DELETE_COMMENT_V2 = '/scenario/comments_v2/delete/';

export const UPDATE_COMMENT = '/scenario/comments/update/';

export const DELETE_COMMENT = '/scenario/comments/delete/';

export const SUBMIT_DRAWER_DATA = '/scenario/planner/opp_submit/';

export const SUBMIT_DRAWER_DATA_v2 = '/scenario/planner_v2/drawer/submit/';

export const SUBMIT_BULK_OPPORTUNITY = '/scenario/planner/bulk_opp_submit/';

export const SUBMIT_BULK_COMMENTS = '/scenario/comments/create/bulk/';

export const DELETE_DRAWER_COMMENTS = '/scenario/planner/drawerdetail/';

export const RESET_DRAWER_DETAILS_V2 = '/scenario/planner_v2/reset/';

export const DELETE_ALL_COMMENTS_AND_OPPORTUNITIES =
  '/scenario/planner/bulk_opp_reset/';

export const GET_LEGENDS = '/scenario/planner/planner_legends/';

export const GET_LEGENDS_V2 = '/scenario/planner_v2/planner_legends/for_grid/';

export const GET_SUMMARY_TABLE_OPPORTUNITIES =
  '/scenario/planner/summary/planner_legends/';

export const GET_SUMMARY_TABLE_OPPORTUNITIES_V2 =
  '/scenario/planner_v2/summary/planner_legends/for_summary/';

export const GET_BULK_INPUTS_TABLE_OPPORTUNITIES =
  '/scenario/planner/bulkinputs/planner_legends/';

export const GET_BULK_INPUTS_TABLE_OPPORTUNITIES_V2 =
  '/scenario/planner_v2/bulkinputs/planner_legends';

export const GET_SKU_METADATA = '/scenario/innovation/v2/create_sku_metadata/';

export const GET_OVERWRITE_SKU_METADATA =
  '/scenario/manual_overwrite/get_data/';

export const OVERWRITE_SKU_METADATA = '/scenario/manual_overwrite/submit/';

export const CREATE_SKU = '/scenario/innovation/v2/create_sku_temp/';

export const GET_TOGGLE_DATA = '/scenario/planner_v2/toggle_level_mapping/';

export const GET_PRODUCT_DRAWER_DATA = '/scenario/planner_v2/drawer_view/';

export const GET_OPPORTUNITY_SUMMARY_TABLE_DATA =
  '/scenario/planner_v2/drawer/';

export const GET_OPPORTUNITY_SUMMARY_TABLE_DATA_V2 =
  '/scenario/planner_v2/summary/';

export const EDIT_SKU = '/scenario/innovation/v2/update_sku_temp/';

export const DELETE_SKU = '/scenario/innovation/v2/delete_sku_temp/';

export const DUPLICATE_SKU = '/scenario/innovation/v2/duplicate_sku/create/';

export const GET_INNOVATION_TABLE_DATA = '/scenario/innovation/v2/get_data/';

export const GET_DUPLICATE_DIALOG_FILTERS =
  'scenario/innovation/v2/duplicate_filters/';

export const GET_SKU_LIST_TABLE =
  '/scenario/innovation/v2/duplicate_sku/get_data/';

export const FETCH_SIMULATED_INNOVATION_DATA =
  '/scenario/innovation/v2/simulate/';

export const SAVE_INNOVATION_SIMULATION = '/scenario/innovation/v2/save_data/';

export const RESET_INNOVATION_SIMULATION =
  '/scenario/innovation/v2/reset_data/';

export const GET_SELECTED_SEGMENT_DETAILS = '/dashboards/source/details/';

export const GET_SOURCE_LIST = '/srm_home/filterpanel/';

export const GET_HOME_PAGE_METADATA = '/homepage/overview/';

export const FETCH_ENHANCEMENT_POP_DATA = '/homepage/tool-information/';

export const GET_BUSINESS_QUESTION_POPUP_DATA = 'homepage/business-questions/';

// homepage content api
export const FETCH_FAVOURITE_LIST_DATA = '/homepage/user-favourite/';

export const FETCH_PRODUCT_FEATURE_LIST = '/homepage/tool-information/';

export const FETCH_MARKET_MATURITY_DATA = '/homepage/overview/';

export const FETCH_RECENTLY_OPENED_DATA = '/homepage/user-recent-views/';

export const FETCH_SEARCH_RESULTS = '/homepage/search/';

export const FETCH_USER_PROFILE_DATA = '/homepage/quick-start/profile/';

export const FETCH_USER_CATEGORY_DATA = '/homepage/quick-start/category/';

export const FETCH_ANNOUNCEMENTS_DATA = '/homepage/announcement-mappings/';

export const GET_MODULES_LIST = '/scenario/modules/';

export const GET_USER_GUIDE = '/srm_home/usermanual/download/';

export const GET_LEGAL_DOC = '/homepage/legal-doc/download/';

export const GET_SCENARIO_DETAILS = '/scenario/retrieve/';

export const GET_PBI_URL = '/getembedurl/';

export const FETCH_POTENTIAL_RISK_DATA = '/scenario/summary/upsides/simulate/';

export const GET_TABLE_DATA_FOR_SCENARIO_MANAGER =
  '/scenario-manager/scenario/';

export const GET_TABLE_DATA_FOR_SCENARIO_LIST =
  '/scenario-manager/scenario-list/';

export const DELETE_SCENARIOS = '/scenario-manager/scenario/delete/';

export const ARCHIVED_SCENARIOS = '/scenario-manager/scenario/archive/';

export const UN_ARCHIVED_SCENARIOS = '/scenario-manager/scenario/unarchive/';

export const MARK_FINALIZED_SCENARIOS =
  '/scenario-manager/scenario/mark-finalized/';

export const UNMARK_FINALIZED_SCENARIOS =
  '/scenario-manager/scenario/unmark-finalized/';

export const SHARE_SCENARIO = '/scenario/share/';

export const REMOVE_SCENARIO_SHARE = '/scenario/remove-access/';

export const GET_LIST_OF_SHARED_USERS =
  '/scenario-manager/scenario/shared-users/';

export const GET_LIST_OF_UNSHARED_USERS =
  '/scenario-manager/scenario/unshared-users/';

export const FETCH_PPG_LEVEL_IMPACT_DATA = '/scenario/summary/ppg-level/';

export const FETCH_TOP_LINE_INPUT_DATA =
  '/scenario/pricing/get_top_line_inputs/';

export const FETCH_MULTI_YEAR_ESTIMATE =
  '/scenario/summary/multi-year-estimation/simulate/';

export const RESET_MULTIYEAR_SIMULATION_TABLE =
  '/scenario/summary/multi-year-estimation/reset-simulation/';

export const SAVE_MULTIYEAR_ESTIMATE =
  '/scenario/summary/multi-year-estimation/save/';

export const SAVE_POTENTIAL_RISKS_UPSIDES = '/scenario/summary/upsides/save/';

export const FETCH_AS_IS_GRID = '/scenario/summary/as_is/';

export const FETCH_TO_BE_GRID = '/scenario/summary/to_be/';

export const FETCH_AS_IS_GRID_V2 = '/scenario/as_is_to_be_v2/as_is_grid/';

export const FETCH_TO_BE_GRID_V2 = '/scenario/as_is_to_be_v2/to_be_grid/';

export const FETCH_COLOR_GRADIENT_FOR_GRID =
  '/scenario/summary/to_be/gradient/';

export const FETCH_COLOR_GRADIENT_FOR_GRID_V2 =
  '/scenario/summary_v2/to_be/gradient/';

export const FETCH_AS_IS_SUMMARY_BAR_CHART =
  '/scenario/summary/asis_tobe/barchart/';

export const FETCH_SCENARIO_COMP_METRICS_BAR_CHARTS =
  '/scenario-comparison/compare/';

export const GET_SUMMARY_DOWNLOAD_DATA = '/scenario/summary/download/';

export const GET_CURRENCY_TOGGLE_DATA = '/scenario/summary/toggle-currency/';

export const GET_CURRENCY_TOGGLE_STATE = '/scenario/summary/toggle-currency/';

export const GET_CLUSTER_SUMMARY_DATA = '/cluster-summary/scenario/list/'

// export const DateFormat = 'MM/DD/YYYY';
export const monthNames = [
  'Jan',
  'Feb',
  'Mar',
  'Apr',
  'May',
  'Jun',
  'Jul',
  'Aug',
  'Sept',
  'Oct',
  'Nov',
  'Dec'
];

export const THOUSAND_VALUE_CONVERT_NUM = 1000;

export const MILLION_VALUE_CONVERT_NUM = 1000000;

export const BILLION_VALUE_CONVERT_NUM = 100000000;

/* Regex Pattern for Number format */

/* The regex pattern to check whether the number format 
"#####0.00,,," contains commas or not */
export const REGEX_FOR_ABBREVIATE = '(#+)(,)(#+)(0)([.]?)(0*)(,+)';

/* The regex pattern to check whether the number format 
"#####0.00" contains decimal*/
export const REGEX_FOR_DECIMAL = '((#+)(0)[.](0+))';

/* The regex pattern to check whether the number format 
"##,###0.00" is comma separated */
export const REGEX_FOR_COMMA_SEPARATED_VALUE = '(#(,+))';

/* The regex pattern to check whether the number format 
"##,###0" is whole number */
export const REGEX_FOR_WHOLE_NUMBER = '(#+)(,)(#+)(0)(?![.])';

export const IMPLEMENTATION_PERIOD_1_KEY = "pricing_implement_after_cal_1"
export const IMPLEMENTATION_PERIOD_2_KEY = "pricing_implement_after_cal_2"
export const PDF_URL = "https://team.effem.com/:p:/r/sites/ODDAPORTAL/Shared%20Documents/Content%20%26%20Templates/Content/Product%20Assets/Browse%20By%20Product/PPA%20Edge/Training%20Collateral/Gaining%20Access/PPA%20EDGE%20-%20Logging%20in.pptx?d=w877ce4f5c10645f48d1c9d86ebc72672&csf=1&web=1&e=KkDaCt"
export const SNOW_TICKET_URL = "https://marsprod.service-now.com/sp?id=incident_helper"